export default __webpack_public_path__ + "static/media/ic_map_usa_hub.76d53ab9.svg";